import { clsx } from 'clsx';

import { LineSkeletonProps, LineSkeleton } from './LineSkeleton';

export const ParagraphSkeleton = ({
  columns = [12, 10, 7],
  variant = 'body',
  className,
}: {
  columns: LineSkeletonProps['cols'][];
  variant?: LineSkeletonProps['variant'];
  gap?: number;
  className?: string;
}) => {
  return (
    <div className={clsx('paragraph-skeleton-container', className)}>
      {columns.map((cols, index) => (
        <LineSkeleton key={`${cols}-${index}`} variant={variant} cols={cols} />
      ))}
    </div>
  );
};
